import React, { useMemo } from 'react';

import kamaCategories from '../../data/languages/kama/categories';
import { CategoryData, LearnedWord, WordData } from '../../types/types';
import KamaLearnMode from './KamaLearnMode';
import './KamaCategoryPreview.css';

interface KamaCategoryPreviewProps {
  category: string;
  words: [string, WordData][];
  onBack: () => void;
  nextLesson?: { label: string; onStart: () => void };
  onLessonComplete?: (category: string, words: LearnedWord[], isFinalSegment?: boolean) => void;
  onAnswer?: (correct: boolean) => void;
  // Excludes narrative/methodology entries from the post-browse test — see
  // KamaLearnMode.tsx's `isTestableWord` prop for the full rationale.
  isTestableWord?: (key: string) => boolean;
}

// Replaces the generic CategoryPreview → LearnMode path for Kama: the node
// click goes straight to browsing the category's words as active cards
// (HieroglyphCard via KamaLearnMode). There is no further "start the lesson"
// step yet — this screen is the destination, not a preview of one.
const KamaCategoryPreview: React.FC<KamaCategoryPreviewProps> = ({
  category,
  words,
  onBack,
  nextLesson,
  onLessonComplete,
  onAnswer,
  isTestableWord,
}) => {
  const categoryData: CategoryData = useMemo(() => Object.fromEntries(words), [words]);

  return (
    <div className="kama-category-preview-overlay">
      <KamaLearnMode
        categoryLabel={category}
        categoryData={categoryData}
        categories={kamaCategories}
        onExit={onBack}
        nextLesson={nextLesson}
        onLessonComplete={onLessonComplete}
        onAnswer={onAnswer}
        isTestableWord={isTestableWord}
      />
    </div>
  );
};

export default KamaCategoryPreview;
